import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleButtonOnClick, handleCombineOdds } from "./Index";
import { getFromLocalStorage } from "../utils/local-storage";
import { useNavigate } from "react-router-dom";

export const Widget = ({
  pathname,
  betslipsData,
  user,
  width,
  live,
  prevKeysRef,
  showWidget,
  // handleButtonOnClick,
}) => {
  const [, setBetSlipState] = useState({
    betslip: [],
    combinedOddsValue: undefined,
  });

  const dispatchRedux = useDispatch();
  const [settings] = useState(getFromLocalStorage("settings"));
  const navigate = useNavigate();

  const handleButtonOnClickWrapper = (target, event) => {
    // Pass the necessary arguments to the handleButtonOnClick function
    handleButtonOnClick(
      target,
      event,
      navigate, // navigate function
      handleCombineOdds, // handleCombineOdds function
      dispatchRedux, // dispatchRedux function
      settings, // settings object
      setBetSlipState, // setBetSlipState function
      live // live flag
    );
  };

  

  useEffect(() => {

    if (pathname.includes("betslip-slip") || width > 991) {
      console.log("wew are here now .. ");
      // Extract all keys from betslipsData and reverse the array
      const allKeys = Object.keys(betslipsData || []).reverse();

      // Check if there is a new key added
      const isNewKeyAdded = allKeys.some(
        (key) => !prevKeysRef.current.includes(key)
      );

      // Check if any key is removed
      const isKeyRemoved = prevKeysRef.current.some(
        (key) => !allKeys.includes(key)
      );

      if (isNewKeyAdded || isKeyRemoved) {
        prevKeysRef.current = allKeys;

        window.SIR(
          "addWidget",
          "#sr-widget-bets",
          "betRecommendation.similarBets",
          {
            maxRows: 1,
            cardsLayout: "horizontal",
            similarEventIds: allKeys, // Pass the reversed array directly
            onItemClick: handleButtonOnClickWrapper,
            user: user ? user.profile_id : null,
            sportsMapping: {
              172: 10,
            },
          }
        );
      }
    }
  }, [betslipsData]);

  return (
    <div className="widgets mt-3 mobile-widget-position">
      <div>
        {
          <h4 className="px-4 mb-0 mt-5" style={{ color: "var(--grey)" }}>
            Recommended Picks
          </h4>
        }

        <div id="sr-widget-bets" className="sr-widget"></div>
      </div>
    </div>
  );
};
